import axios from "../utils/axios";

let dashboardApi = {
   dashboard: () => axios({
      url: '/v1/admin/dashboard',
      method: 'get',
      headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
      },
   }),

}

export default dashboardApi
